import React from 'react';
import AuthComponent from '../components/auth-component';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { AuthDelegate } from '../utils';
import { accountConstants, routes, fetchTypes, requestStatus, menus, reduxActions } from '../constants';
import { Card, DateGridCell, ApprovalGridCell, DataGrid, DataColumn, SearchBar, Menu, MenuItem, DataGridPager, ButtonGridCell, SearchText, SearchButton, TabSet, Tab, Button } from '../components';
import { RouteActions, ResourceActions, UserManagementActions } from '../actions';

const { roles } = accountConstants;
const tabs = menus.ADMIN_USERS;

const isAdmin = AuthDelegate.userHasRole(roles.ADMIN);

class AccountManagementPage extends AuthComponent {

    componentDidMount() {
        this.props.dispatch(RouteActions.setAppState(routes.USER_MANAGEMENT));
    }

    userIsAuthorized(user) {
        return isAdmin(user);
    }

    userDidAuthorize() {
        this.queryPending();
    }

    queryPending(params = {}) {
        const currentParams = {
            pageNumber: this.props.queue.currentPageNumber,
            searchText: '',
            searchTextCompare: 'Contains',
            sortOrder: 'ASC',
            orderBy: 'Email',
            pageSize: this.props.queue.pageSize,
            accessRevoked: false
        }

        params = Object.assign({}, currentParams, params);
        this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.APPROVAL_QUEUE, params));
    }

    queryRegistered(params = {}) {
        const currentParams = {
            pageNumber: this.props.adminUserList.currentPageNumber,
            searchText: '',
            searchTextCompare: 'Contains',
            sortOrder: 'ASC',
            orderBy: 'Email',
            pageSize: this.props.adminUserList.pageSize,
            accessRevoked: false
        }
        params = Object.assign({}, currentParams, params);
        this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.USER_SEARCH, params));
    }

    queryRevoked(params = {}) {
        const currentParams = {
            pageNumber: this.props.adminRevokedUserList.currentPageNumber,
            searchText: '',
            searchTextCompare: 'Contains',
            sortOrder: 'ASC',
            orderBy: 'Email',
            pageSize: this.props.adminUserList.pageSize,
            accessRevoked: true
        }
        params = Object.assign({}, currentParams, params);
        this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.USER_REVOKED_SEARCH, params));
    }

    revokeUser(id) {
        this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.USER_REVOKE_ACCESS, {
            userId: id
        }));
    }

    manageUser(id){
        browserHistory.push(routes.SET_SECURITY + '?id=' + id);
    }

    restoreUser(id) {
        this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.USER_RESTORE_ACCESS, {
            userId: id
        }));
    }

    componentWillRejectUser() {
        browserHistory.push(routes.NOT_FOUND);
    }

    componentWillReceiveProps(props) {
        if (props.queue.removedUserId && props.queue.removedUserRole.trim() === 'Oem') {
            this.props.dispatch({
                fetchType: fetchTypes.USER_APPROVE,
                type: reduxActions.RESOURCE_RESET
            });
            this.manageUser(props.queue.removedUserId);
        }
    }

    menuDidUpdate(key) {
        this.props.dispatch(UserManagementActions.setTabState(key));
        switch (key) {
            case tabs.PENDING:
                this.queryPending();
                break;
            case tabs.REGISTERED:
                this.queryRegistered();
                break;
            case tabs.REVOKED:
                this.queryRevoked();
                break;
        }
    }

    renderPendingGrid(data) {
        let pagerConfig = Object.assign({}, this.props.queue, {
            onPageChange: (newPage) => {
                this.queryPending({
                    pageNumber: newPage
                });
            }
        });

        return (
            <div className="grid-wrapper col-sm-12">
                <DataGrid data={data} isLoading={this.props.queue.progress === requestStatus.BUSY}>
                    <DataColumn columnName="id" displayName="ID" />
                    <DataColumn columnName="email" displayName="Email" />
                    <DataColumn columnName="sampleNumber" displayName="Sample Number" />
                    <DataColumn columnName="serialNumber" displayName="Serial Number" />
                    <DataColumn columnName="postalCode" displayName="Postal Code" />
                    <DataColumn columnName="dateSubmitted" displayName="Date Submitted" cellComponent={DateGridCell} />
                    <DataColumn columnName="approve" displayName="Approve?" cellComponent={ApprovalGridCell} />
                </DataGrid>
                <DataGridPager config={pagerConfig} />
            </div>
        )
    }

    renderRegisteredGrid(data) {
        let pagerConfig = Object.assign({}, this.props.adminUserList, {
            onPageChange: (newPage) => {
                this.queryRegistered({
                    pageNumber: newPage
                })
            }
        });

        return (
            <div className="grid-wrapper col-sm-12">
                <DataGrid data={data} isLoading={this.props.adminUserList.progress === requestStatus.BUSY}>
                    <DataColumn columnName="displayName" displayName="Display Name" />
                    <DataColumn columnName="email" displayName="Email" />
                    <DataColumn columnName="roles" displayName="Roles" />
                    <DataColumn columnName="revoke" displayName="" cellComponent={ButtonGridCell} cellComponentProps={{ text: 'Revoke Access', onClick: (e, data, rowData) => this.revokeUser(rowData.userId) }} />
                    <DataColumn columnName="manage" displayName="" cellComponent={ButtonGridCell} cellComponentProps={{ text: 'Manage', onClick: (e, data, rowData) => this.manageUser(rowData.userId) }} />
                </DataGrid>
                <DataGridPager config={pagerConfig} />
            </div>
        )
    }

    renderRevokedGrid() {
        let pagerConfig = Object.assign({}, this.props.adminRevokedUserList, {
            onPageChange: (newPage) => {
                this.queryRevoked({
                    pageNumber: newPage
                })
            }
        });

        return (
            <div className="grid-wrapper col-sm-12">
                <DataGrid data={this.props.adminRevokedUserList.results} isLoading={this.props.adminRevokedUserList.progress === requestStatus.BUSY}>
                    <DataColumn columnName="displayName" displayName="Display Name" />
                    <DataColumn columnName="email" displayName="Email" />
                    <DataColumn columnName="roles" displayName="Roles" />
                    <DataColumn columnName="actions" displayName="" cellComponent={props => (<Button onClick={() => this.restoreUser(props.rowData.userId)}>Restore Access</Button>)} />
                </DataGrid>
                <DataGridPager config={pagerConfig} />
            </div>
        )
    }

    authRender() {

        return (
            <div className="container" id="container-user-management">
                <div className="row center-cols">
                    <div className="col-sm-8 page-header">
                        <h1 className="page-title">User Management</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <Card>
                            <div className="card-title-area">
                                <Menu className="no-collapse" defaultItem={this.props.adminTabState} onChange={key => this.menuDidUpdate(key)}>
                                    <MenuItem itemId={tabs.PENDING}>Pending</MenuItem>
                                    <MenuItem itemId={tabs.REGISTERED}>Registered</MenuItem>
                                    <MenuItem itemId={tabs.REVOKED}>Revoked</MenuItem>
                                </Menu>
                            </div>
                            <div className="card-body row">
                                <TabSet className="desktop-padding" switch={this.props.adminTabState}>
                                    <Tab value={tabs.PENDING}>
                                        <div className="search-area col-sm-12">
                                            <SearchBar className="col-sm-6" onSearch={search => this.queryPending({ searchText: search.text })}>
                                                <SearchText name="text" defaultValue="" />
                                                <SearchButton className="primary" />
                                            </SearchBar>
                                        </div>
                                        { this.renderPendingGrid(this.props.queue.results) }
                                    </Tab>
                                    <Tab value={tabs.REGISTERED}>
                                        <div className="search-area col-sm-12">
                                            <SearchBar className="col-sm-6" onSearch={search => this.queryRegistered({ searchText: search.text })}>
                                                <SearchText name="text" defaultValue="" />
                                                <SearchButton className="primary" />
                                            </SearchBar>
                                        </div>
                                        { this.renderRegisteredGrid(this.props.adminUserList.results) }
                                    </Tab>
                                    <Tab value={tabs.REVOKED}>
                                        <div className="search-area col-sm-12">
                                            <SearchBar className="col-sm-6" onSearch={search => this.queryRevoked({ searchText: search.text })}>
                                                <SearchText name="text" defaultValue="" />
                                                <SearchButton className="primary" />
                                            </SearchBar>
                                        </div>
                                        { this.renderRevokedGrid() }
                                    </Tab>
                                </TabSet>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}

const select = (state) => {
    return {
        currentRoute: state.appState.currentRoute,
        queue: state.userApprovalQueue,
        adminUserList: state.adminUserList,
        adminRevokedUserList: state.adminRevokedUserList,
        adminTabState: state.adminTabState,
        user: state.activeUser
    }
}

export default connect(select)(AccountManagementPage);



// WEBPACK FOOTER //
// ./web-app/containers/user-management.jsx